import axios from "axios"

const pagination = document.querySelector('[js-pagination]')
const search = document.querySelector('[js-search]')
const reset = document.querySelector('[js-search-reset]')
const list = document.querySelector('[js-pagination-list]')
const loader = document.querySelector('[js-pagination-load]')
const baseUrl = document.querySelector('[js-api-url]').dataset.uri

const template = `
<a href="{{url}}" class="story-card">
  <div class="story-card_img">
    <img src="{{img}}" alt="{{title}}" />
  </div>
  <div class="story-card_content">
      <p class="story-card_date tagline">{{date}}</p>
      <h3 class="">{{title}}</h3>
      <p>{{content}}</p>
  </div>
</a>
`
const url = new URL(window.location)

// State ---------
const state = {
  page: pagination ? parseInt(pagination.dataset.page) : 0,
  total: 0,
  max: 9,
  query: '',
  url: url,
}

if (pagination) {
  const items = pagination.querySelectorAll('[js-pagination-item]')
  const next = pagination.querySelector('[js-pagination-next]')
  const prev = pagination.querySelector('[js-pagination-prev]')

  state.total = items.length

  if (items) {
    for(const item of items) {
      item.addEventListener('click', () => {
        update(item)
      })
    }

    next.addEventListener('click', () => {
      const nextIndex = state.page + 1
      update(items[nextIndex - 1])
    })
    prev.addEventListener('click', () => {
      const prevIndex = state.page - 1
      update(items[prevIndex - 1])
    })
  }

  if (search) {
    const searchInput = search.querySelector('[js-search-input]')
    search.addEventListener('submit', (e) => {
      e.preventDefault()
      state.query = searchInput.value
      state.page = 1

      if (searchInput.value !== '') {
        reset.style.display = 'block'
      } else {
        reset.style.display = 'none'
      }

      updateList()
      resetPage()
    })
    reset.addEventListener('click', (e) => {
      e.preventDefault()
      searchInput.value = ''
      state.query = ''
      state.page = 1
      reset.style.display = 'none'

      updateList()
      resetPage()
    })
  }
}

// GET DATA FROM API
async function getItems(args) {
  try {
    const type = search.dataset.type || pagination.dataset.type || 'post'
    const params = new URLSearchParams(args).toString()
    const items = await axios.get(`${baseUrl}/wp-json/wp/v2/${type}?${params}`)

    return items
  } catch(e) {
    return {
      error: e,
    }
  }
}

// CREATE LIST
function createList({ data }) {
  return data.map(item => {
    let nTemplate = template
    nTemplate = nTemplate.replace('{{date}}', item.date_format)
    nTemplate = nTemplate.replaceAll('{{title}}', item.title.rendered, 'g')
    nTemplate = nTemplate.replace('{{img}}', item.featured_image_src)
    nTemplate = nTemplate.replace('{{content}}', item.content_format)
    nTemplate = nTemplate.replace('{{img}}', item.featured_image_src)
    nTemplate = nTemplate.replace('{{url}}', item.link)
    return nTemplate
  }).join('')
}

function updateList() {
  window.scrollTo({
    top: list.offsetTop - 150,
    left: 0,
    behavior: 'smooth',
  })

  loader.style.transition = 'opacity .3s ease-out'
  loader.style.visibility = 'visible'
  loader.style.opacity = 1
  loader.style.zIndex = 10
  list.style.transition = 'all .6s ease-out'
  list.style.opacity = 0
  list.style.transform = `translateY(50px)`

  // TODO MOBILE
  setTimeout(async () => {
    list.style.height = `${list.offsetHeight}px`
    list.innerHTML = ''
    loader.style.visibility = 'visible'
    loader.style.opacity = 1
    const data = await getItems({
      per_page: window.innerWidth < 768 ? 6 : 9,
      page: state.page,
      status: 'publish',
      search: state.query,
      _embed: true,
    })

    if (data.data.length > 0) {
      pagination.attributeStyleMap.clear()
      list.innerHTML = createList(data)
    } else {
      pagination.style.transition = 0
      pagination.style.transitionDelay = 0
      pagination.style.visibility = 'hidden'
      list.innerHTML = `<p class="no-results">No results found for your search <span>${state.query}</span></p>`
    }
    loader.style.visibility = 'hidden'
    loader.style.opacity = 0
    loader.style.zIndex = -1
    list.style.opacity = 1
    list.style.transform = `translateY(0px)`
    list.style.height = 'auto'
  }, 600)
}

function updateNav() {
  const next = pagination.querySelector('[js-pagination-next]')
  const prev = pagination.querySelector('[js-pagination-prev]')

  if (state.page === 1) prev.disabled = true
  else prev.disabled = false
  if (state.page === state.total) next.disabled = true
  else next.disabled = false
}

function updatePage(item) {
  state.page = parseInt(item.dataset.page)

  pagination.querySelector('[js-pagination-item].current').classList.remove('current')
  item.classList.add('current')

  const nextUrl = state.page > 1 ? `page/${state.page}` : ''
  window.history.pushState({}, '', `${state.url}${nextUrl}`)
}

async function resetPage() {
  state.page = 1
  pagination.querySelector('[js-pagination-item].current').classList.remove('current')
  const items = pagination.querySelectorAll('[js-pagination-item]')
  items[0].classList.add('current')

  // LOAD MORE DATA
  const articles = await getItems({
    per_page: 100,
    status: 'publish',
    search: state.query,
  })

  const total = Math.ceil(articles.data.length / 3)
  state.total = total

  Array.from(items).map((item, index) => {
    if (index >= state.total) {
      item.style.display = 'none'
    } else {
      item.style.display = 'flex'
    }
  })

  pagination.querySelector('[js-pagination-prev]').disabled = true
  pagination.querySelector('[js-pagination-next]').disabled = state.total === 1
}

function update(item) {
  updatePage(item)
  updateNav()
  updateList()
}